export function emptyEpisode() {
  return {
    subtitle: null,
    image_key: null,
    file_url: "",
    image: "",
    logo: "",
    logoFile: null,
    duration: 0,
    guid: "",
    size: 0,
    title: "",
    published: true,
    upload_status: "",
    rich_description: null,
    description: "",
    tags: [],
    season: "",
    link: null,
    key: "",
    podcast: "",
    episode: "",
    episode_type: "full",
    author: "",
    explicit: false,
    summary: null,
    publish_date: "",
    duration_hms: "",
    episode_source: "",
    block: false,
    // RSS feed fields (Apple and Podcasting 2.0)
    itunes_title: "",
    ai_content: false,
    license: "",
    license_url: "",
    content_link: "",
    content_link_text: "",
    chapters: [],
    people: [],
    // set by the transcript upload, not by the form
    transcript_url: null,
    transcript_type: null,
  }
}

function initialState() {
  return {
    episodes: null,
    episode: emptyEpisode(),
  }
}

let state = initialState()

export { initialState, state }
